async function invokeFnAsync(fn, args) {
  return fn && await fn(...args || []);
}
function invokeFnSync(fn, args) {
  return fn && fn(...args || []);
}
export {
  invokeFnAsync,
  invokeFnSync
};
//# sourceMappingURL=invokeFn.js.map
